import moment from 'moment';
import React from 'react';
import { DivisionIcon, VCIcon } from '../Buttons/TypeIcons';
import Stars from '../Stars';
import colours from './Colours';
import HighLighter from './HighLighter';
import Icon from './Icons/Icon';
import { P2Bold, P3, P3Bold, CaptionSmall } from './Text';

const BookingResultCard = (props) => {

    let { booking, search_term } = props;
    
    const inactiveIconStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05}
    const activeIconStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}
    
    let releaseIconContainerStyle = inactiveIconStyle;
    let returnIconContainerStyle = inactiveIconStyle;

    if (booking.Released_On) {
        releaseIconContainerStyle = activeIconStyle;
        
        if (booking.Returned_On) {
            returnIconContainerStyle = activeIconStyle;
        }
    }
    
    let profile_name = (booking.First_Name ? booking.First_Name : '') + (booking.Last_Name ? (" " + booking.Last_Name) : '');

    return (
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: 50}}>
            <div style={{display: 'flex', flex: 1, alignItems: 'center', padding: 8}}>
                <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start'}}>
                    <Icon name="Release" size={24} style={releaseIconContainerStyle}/>
                    <div style={{textAlign: 'left', marginLeft: 4, width: 110}}>
                        <P3Bold>
                            <HighLighter 
                                text={moment(booking.Start_Date).format('MMM DD, YYYY')} 
                                searchTerm={search_term} 
                                highlightedItemClass="ds-highlighted-search-text" 
                                itemClass="ds-non-highlighted-search-text"
                            />
                        </P3Bold>
                        <CaptionSmall>{moment(booking.Start_Date + " " + booking.Release_Time).format('hh:mm a')}</CaptionSmall>
                    </div>
                    <Icon name="ArrowRight" size={24} style={{marginLeft: 0, marginRight: 4}}/>
                    <Icon name="CheckIn" size={24} style={returnIconContainerStyle}/>
                    <div style={{textAlign: 'left', marginLeft: 4, width: 110}}>
                        <P3Bold>
                            <HighLighter
                                text={moment(booking.End_Date).format('MMM DD, YYYY')} 
                                searchTerm={search_term} 
                                highlightedItemClass="ds-highlighted-search-text" 
                                itemClass="ds-non-highlighted-search-text"
                            />
                        </P3Bold>
                        <CaptionSmall>{moment(booking.End_Date + " " + booking.Return_Time).format('hh:mm a')}</CaptionSmall>
                    </div>
                    <div style={{marginLeft: 16, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Icon name={booking.Book_Type == 2 ? 
                            "Car" : (booking.profile) && (booking.profile.Is_User == 1) ? "User" : "Tag"} size={24} style={activeIconStyle} 
                        />
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                            <div style={{display: 'flex', flex: 1, flexDirection: 'column', maxHeight: 50}}>
                                <div style={{marginLeft: 4, display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}}>
                                    {booking.Book_Type == 2 ? 
                                    <>
                                        <P3Bold>
                                            <HighLighter
                                                text="Service"
                                                searchTerm={search_term}
                                                highlightedItemClass="ds-highlighted-search-text" 
                                                itemClass="ds-non-highlighted-search-text"
                                            />
                                        </P3Bold>
                                        <P3 style={{color: colours.primary.grey02}}>
                                            <HighLighter
                                                text={booking?.Vehicle_Usage} 
                                                searchTerm={search_term} 
                                                highlightedItemClass="ds-highlighted-search-text" 
                                                itemClass="ds-non-highlighted-search-text"
                                            />
                                        </P3>
                                    </> 
                                    : <>
                                        <HighLighter
                                            text={profile_name} 
                                            searchTerm={search_term} 
                                            highlightedItemClass="ds-highlighted-search-text" 
                                            itemClass="ds-non-highlighted-search-text"
                                        />
                                        {booking.profile.Title && booking.profile.Company? 
                                            <P3 style={{color: colours.primary.grey02}}>{booking.profile.Title + " at " + booking.profile.Company}</P3>
                                            : null
                                        }
                                    </>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { booking.profile && booking.profile.sh_vmh_access && booking.profile.sh_vmh_access.length > 0 ?
                    <div className="addexp-booking-search-result-li-fix" style={{maxHeight: 36, display: 'flex', justifySelf: 'flex-end', alignItems: 'center'}}>
                        <Stars type={"Profile"} ID={booking.profile.ID} star={(booking.profile.sh_vmh_access[0].tier.Rank)}/>
                    </div>
                : null }
            </div>
        </div>
    )
}


export default BookingResultCard;